import { currentUser } from "@/features/account/services/accountService";
import { createCompletion } from "@/services/completion";

function getDefaultState() {
    return {
        user: null,
        policies: null,
        isLoggedIn: false,
        isLoaded: false,
        loadCompletion: createCompletion()
    }
}

const state = getDefaultState();

const getters = {
    staffMemberId: (state) => state.user?.staffMemberId,
    hasPolicy: (state) => (policy) => state.policies?.has(policy) ?? false
};

const actions = {
    async load({ commit, dispatch }) {
        await dispatch("refreshUser");
        commit("loaded");
        state.loadCompletion.complete();
    },

    async loadCompletion({ state }) {
        await state.loadCompletion();
    },

    async login(_, returnUrl) {
        window.location.href = `/Auth/Login?returnUrl=${encodeURIComponent(returnUrl)}`;
    },

    async logout({ commit }) {
        commit("clear");
        window.location.href = "/Auth/Logout";
    },

    async refreshUser({ commit }) {
        const user = await currentUser();
        if (user !== null) {
            commit("user", user);
        }
    },
    setSettings({ commit, dispatch }, settings) {
        commit("settings", settings);
        dispatch("localisation/load", null, { root: true });
    },
};

const mutations = {
    user(state, user) {
        state.user = user;
        state.policies = new Set(user.policies);
        state.isLoggedIn = true;
    },
    settings(state, settings) {
        if (state.user) {
            Object.assign(state.user, settings);
        }
    },
    loaded(state) {
        state.isLoaded = true;
    },
    clear(state) {
        state.user = null;
        state.isLoggedIn = false;
    }
};

export const authentication = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
